import { api } from "api/api";
import { AxiosError } from "axios";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import ViagemTipoDespesa from "model/viagem/ViagemTipoDespesa";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class ViagemTipoDespesaService implements BaseServiceCadastros<ViagemTipoDespesa> {

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/viagemTipoDespesa/pesquisar`;
            url += getFilters(filters);

            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<ViagemTipoDespesa>((resolve, reject): void => {
            api
                .get(`/viagemTipoDespesa/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(viagemTipoDespesa: ViagemTipoDespesa) {
        return new Promise<ViagemTipoDespesa>((resolve, reject): void => {
            api
                .post(`/viagemTipoDespesa/incluir`, JSON.stringify(viagemTipoDespesa))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(viagemTipoDespesa: ViagemTipoDespesa) {
        return new Promise<ViagemTipoDespesa>((resolve, reject): void => {
            api
                .put(`/viagemTipoDespesa/editar`, JSON.stringify(viagemTipoDespesa))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/viagemTipoDespesa/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

}

export default ViagemTipoDespesaService;